export default class AnalyseErrorTypeDto {
    constructor(obj) {
        this.code = obj.code
        this.label = obj.label
        this.errorType = obj.errorType
        this.controlType = obj.controlType
    }
}